import { LoadingSkeleton } from '@/components/SkeletonLoading';
import {
  Table,
  TableProps,
  TRecordType,
} from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import styles from './BorderTable.module.scss';

const cx = classNames.bind(styles);

type Props<RecordType extends TRecordType> = TableProps<RecordType> & {
  disableRowStyling?: boolean;
};

export const BorderTable = <RecordType extends TRecordType>({
  disableRowStyling = false,
  ...props
}: Props<RecordType>) => {
  return (
    <div className={styles['border-table-container']}>
      {props.emptyType === 'loading' && !props.hideHeaderPagination && (
        <div className={styles['border-table-loading-pagination']}>
          <LoadingSkeleton />
        </div>
      )}
      <Table
        {...props}
        className={cx(
          styles['border-table'],
          styles['border-table-scroll'],
          disableRowStyling && styles['border-table--no-row-highlighting'],
          props.emptyType === 'loading' && styles['border-table-loading']
        )}
      />
      {!props.hideFooterPagination && props.emptyType === 'loading' && (
        <div className={styles['border-table-loading-pagination']}>
          <LoadingSkeleton />
        </div>
      )}
    </div>
  );
};

BorderTable.displayName = 'BorderTable';
